import Vue from 'vue';
import VueResource from 'vue-resource';
import ApiClient from '@/models/api/apiClient';
import MockApiClient from '@/models/api/mockApiClient';
import RestApiClient from '@/models/api/restApiClient';
import { currentState as apiConfig } from '@/store/modules/configuration';

Vue.use(VueResource);

export const apiClient: ApiClient = process.env.NODE_ENV === 'development' ?
    new RestApiClient(Vue.http, apiConfig) : new RestApiClient(Vue.http, apiConfig);
    //new MockApiClient() : new MockApiClient()//new RestApiClient(Vue.http, apiConfig);

Vue.prototype.$api = apiClient;

declare module 'vue/types/vue' {
    interface Vue {
        $api: ApiClient;
    }
}
